import React from 'react';
import { Box, IconButton, Stack, Select } from '@chakra-ui/react';
import { UilEyeSlash, UilMobileAndroid, UilTablet, UilDesktop } from '@iconscout/react-unicons';
import VtexVisualizationComponent from './VtexVisualizationComponent';
import { selectedPageObject, headerPageObject, footerPageObject } from '../../redux/pagesSlice';
import { allPages } from '../../redux/pagesSlice';
import { useDispatch, useSelector } from 'react-redux';
import { selectedToggleValue } from '../../redux/canvasResolutionSlice';
import CanvasCSSVariablesImport from './CanvasCSSVariablesImport';
import { selectPage } from '../../redux/selectedPageSlice';
import VisualizationIframe from './VisualizationIframe';
import theme from '../../utils/ChakraTheme';
import { ChakraProvider } from '@chakra-ui/react';
import VtexFixedComponent from './VtexFixedComponent';
import { toggleMobile } from '../../redux/canvasResolutionSlice';
import { visualizationMode, setVisualizationMode } from '../../redux/visualizationModeSlice';
import IconPackImport from './IconPackImport';
import { IntlProvider } from 'react-intl';
import VisualizationIframeContent from './VisualizationIframeContent';

const y300 = { bg: 'yellow.300', borderColor: 'yellow.300' };
const y400 = { bg: 'yellow.400', borderColor: 'yellow.400' };

// function selectRes({ w, h, setResolution, index, setSelected }) {
//     setResolution({ w, h })
//     setSelected(index)
// }

const getFilteredPages = (pages) => {
	return pages.filter((page) => page.pageId !== 'header' && page.pageId !== 'footer');
	// return []
};

const selectPageHandle = ({ e, dispatch }) => {
	window.location.hash = e.target.value;
	dispatch(selectPage(e.target.value));
};

const VisualizationMode = ({ viewId }) => {
	const selectedPage = useSelector(selectedPageObject);
	const pages = useSelector(allPages);
	const VMMode = useSelector(visualizationMode);
	// const [resolution, setResolution] = React.useState({ w: '100%', h: '100%' })
	// const [selected, setSelected] = React.useState(0)

	const toggleValue = useSelector(selectedToggleValue);
	const dispatch = useDispatch();

	function handleChange(value) {
		if (toggleValue === value) return;
		dispatch(toggleMobile(value));
	}

	React.useEffect(() => {
		if (selectedPage.pageId == 'header' || selectedPage.pageId == 'footer') {
			dispatch(selectPage('default-1'));
		}
	}, [selectedPage]);

	return (
		<ChakraProvider theme={theme} resetCSS={false}>
			<Box transition={'0.2s'} d={'flex'} w="100%" h="100%" justifyContent="center" bg={'#EDF2F7'}>
				<Box
					opacity={0}
					transition={'.3s'}
					_hover={{ opacity: 1 }}
					position={'fixed'}
					bottom={'15px'}
					left={'30px'}
					zIndex="1001"
				>
					<Stack direction="row">
						<Select
							size={'sm'}
							bg={'white'}
							value={selectedPage.pageId || 'default-1'}
							onChange={(e) => selectPageHandle({ e, dispatch })}
						>
							{getFilteredPages(pages).map((page) => (
								<option value={page.pageId}>{page.pageName} </option>
							))}
						</Select>
						<IconButton
							size={'sm'}
							bg={'white'}
							_hover={y300}
							isActive={toggleValue === 1920}
							_active={y400}
							_focus={y400}
							onClick={(e) => {
								handleChange(1920);
							}}
							variant="outline"
							ml={1}
							aria-label="Lines Layout"
							icon={<UilDesktop size={16} />}
						/>
						<IconButton
							size={'sm'}
							bg={'white'}
							_hover={y300}
							isActive={toggleValue === 1024}
							_active={y400}
							_focus={y400}
							onClick={(e) => {
								handleChange(1024);
							}}
							variant="outline"
							ml={1}
							aria-label="Lines Layout"
							icon={<UilTablet size={16} />}
						/>
						<IconButton
							size={'sm'}
							bg={'white'}
							_hover={y300}
							isActive={toggleValue === 467}
							_active={y400}
							_focus={y400}
							onClick={(e) => {
								handleChange(467);
							}}
							variant="outline"
							ml={1}
							aria-label="Lines Layout"
							icon={<UilMobileAndroid size={16} />}
						/>
						<IconButton
							size={'sm'}
							bg={'white'}
							_hover={y300}
							_active={y400}
							_focus={y400}
							onClick={(e) => {
								dispatch(setVisualizationMode(!VMMode));
							}}
							variant="outline"
							ml={1}
							aria-label="Lines Layout"
							icon={<UilEyeSlash size={16} />}
						/>
					</Stack>
				</Box>
				<VisualizationIframe viewId={viewId} w={toggleValue >= 1080 ? '100%' : toggleValue + 'px'} h={'100%'}>
					<VisualizationIframeContent viewId={viewId} />
				</VisualizationIframe>
			</Box>
		</ChakraProvider>
	);
};

export default VisualizationMode;
